import React from 'react';

const getIndexes = (count: any) => {
  const arr = [];
  for (let i = 0; i < count; i++) {
    arr.push(i);
  }

  return arr;
};

const getListStyles = () => ({
  position: 'relative',
  margin: 0,
  padding: 0,
  whiteSpace: 'nowrap',
  bottom: '-32px',
});

const getListItemStyles = () => ({
  listStyleType: 'none',
  margin: '0 5px',
  display: 'inline-block',
});

const getButtonStyles = (active: any) => ({
  display: 'block',
  background: active ? '#f0006a' : '#dee1e5',
  cursor: 'pointer',
  borderRadius: '50%',
  width: '9px',
  height: '9px',
});

/* eslint-disable */
export const dotsDecorator = ({ goToSlide, slideCount, currentSlide }: any) => {
  const indexes = getIndexes(slideCount);
  return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '"inherit"... Remove this comment to see the full error message
    <ul style={getListStyles()}>
      {indexes.map((index) => (
        <li style={getListItemStyles()} key={index}>
          <span
            style={getButtonStyles(currentSlide === index)}
            onClick={goToSlide.bind(null, index)}
          />
        </li>
      ))}
    </ul>
  );
};
/* eslint-enable */
